import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import styled, { css, keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import connect from '../../store/connect';
import { setViewstate, removeViewstate, removeQuickSearch } from '../../actions/actionCreators';
import { breakpoint, color } from '../../styles/helpers/variables';
import { Container } from '../../styles/Container';
import MobileMainMenu from './MobileMainMenu';
import Overlay from '../Overlay';
import { showOnPrint, hideOnPrint } from '../../styles/helpers/mixins';
import MenuCart from '../MenuCart';
import SearchResults from '../SearchResults';
import SearchInput from './SearchInput';
import MainMenu from './MainMenu';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolledToTop: true
    };
    this.onScroll = this.onScroll.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const oldScrolledToTopState = this.state.scrolledToTop;
    this.setState({
      scrolledToTop:
        window.pageYOffset <= 25 + 35 && document.getElementsByTagName('body')[0].style.position !== 'fixed'
    });
    if (
      oldScrolledToTopState !== this.state.scrolledToTop &&
      !this.state.scrolledToTop &&
      this.props.viewstate.get('activeMenuItem')
    ) {
      this.props.removeViewstate('activeMenuItem');
    }
  }

  handleOverlayClick() {
    this.props.setViewstate('globalSearchActive', false);
    this.props.removeQuickSearch();
  }

  render() {
    const { headerUspList, headerUSPVariantSecondary, headerUSPShowIcons } = this.props;
    const isCheckoutPage = this.props.location.pathname === '/kassa';
    const isOrderConfirmationPage = this.props.location.pathname === '/tack';

    const printableHeader = (
      <PrintableHeader>
        <img src="/images/valamagasinet_logo_black.svg" alt="Vålamagasinet" />
      </PrintableHeader>
    );

    if (isCheckoutPage || isOrderConfirmationPage) {
      return (
        <Fragment>
          {printableHeader}

          <Header123 simple>
            <HeaderMain>
              <Container noPadding>
                <HeaderMainContent simple>
                  <HeaderMainContentReturnToStoreLink>
                    <ReturnToStoreLink to="/">Fortsätt handla</ReturnToStoreLink>
                  </HeaderMainContentReturnToStoreLink>
                  <HeaderMainContentLogo simple>
                    <HeaderLogo to="/" simple>
                      <img src="/images/valamagasinet_logo_white.svg" alt="Vålamagasinet" />
                    </HeaderLogo>
                  </HeaderMainContentLogo>
                </HeaderMainContent>
              </Container>
            </HeaderMain>
          </Header123>
        </Fragment>
      );
    }

    return (
      <Fragment>
        {printableHeader}

        {headerUspList && headerUspList.length > 0 && (
          <HeaderUSP variant={headerUSPVariantSecondary && 'secondary'}>
            <Container noPadding>
              <HeaderUSPList>
                {headerUspList.map(usp => (
                  <HeaderUSPListItem numberOfUSPListItems={headerUspList.length}>
                    {headerUSPShowIcons && (
                      <svg viewBox="0 0 12 9" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.7212 0.278745C11.3499 -0.093032 10.747 -0.0927976 10.3752 0.278745L4.31744 6.33674L1.62503 3.64435C1.25325 3.27257 0.650609 3.27257 0.278832 3.64435C-0.0929441 4.01613 -0.0929441 4.61877 0.278832 4.99055L3.6442 8.35592C3.82998 8.54169 4.07357 8.63481 4.31719 8.63481C4.5608 8.63481 4.80463 8.54192 4.9904 8.35592L11.7212 1.62492C12.0929 1.2534 12.0929 0.650498 11.7212 0.278745Z"
                          fill="white"
                        />
                      </svg>
                    )}
                    <span>{usp}</span>
                  </HeaderUSPListItem>
                ))}
              </HeaderUSPList>
            </Container>
          </HeaderUSP>
        )}

        <Header123>
          <HeaderMain>
            <Container noPadding>
              <HeaderMainContent>
                <HeaderMainContentMobileMenuButton>
                  <MobileMenuButton
                    onClick={() => {
                      this.props.setViewstate('mobileMenuActive', !this.props.viewstate.get('mobileMenuActive'));
                      this.props.removeViewstate('activeMenuItem');
                      // this.props.removeQuickSearch();
                      this.props.removeViewstate('globalSearchActive');
                    }}
                  >
                    <MobileMenuButtonIcon active={this.props.viewstate.get('mobileMenuActive')} />
                  </MobileMenuButton>
                </HeaderMainContentMobileMenuButton>
                <HeaderMainContentLogo>
                  <HeaderLogo
                    to="/"
                    onClick={() => {
                      // this.props.removeQuickSearch();
                      this.props.removeViewstate('globalSearchActive');
                    }}
                  >
                    <img src="/images/valamagasinet_logo_white.svg" alt="Vålamagasinet" />
                  </HeaderLogo>
                </HeaderMainContentLogo>
                <HeaderMainContentSearch>
                  <SearchInput />
                </HeaderMainContentSearch>
                <HeaderMainContentCart>
                  <MenuCart />
                </HeaderMainContentCart>
              </HeaderMainContent>
              <HeaderLowerContent>
                <SearchInput />
              </HeaderLowerContent>
            </Container>
          </HeaderMain>
          <HeaderLower active={this.state.scrolledToTop}>
            <Container noPadding>
              <MainMenu />
            </Container>
          </HeaderLower>
          <SearchResults />
          <MobileMainMenu />
        </Header123>

        <Overlay header onClick={this.handleOverlayClick} active={this.props.viewstate.get('globalSearchActive')} />
      </Fragment>
    );
  }
}

const PrintableHeader = styled.div`
  ${showOnPrint};
  > img {
    display: block;
    width: 200px;
    margin: 0 auto;
  }
`;

const Header123 = styled.header`
  position: sticky;
  top: 0;
  z-index: 150;
  ${hideOnPrint};
  @media screen and (min-width: ${breakpoint.large}px) {
    margin: 0 0 35px;
  }
  ${props =>
    props.simple &&
    css`
      margin: 0 !important;
    `};
`;

const HeaderMain = styled.div`
  position: relative;
  padding: 10px 0;
  background-color: ${color.black};
  z-index: 1;
  @media screen and (min-width: ${breakpoint.large}px) {
    padding: 20px 0;
  }
`;
const HeaderMainContent = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 10px;
  @media screen and (min-width: ${breakpoint.large}px) {
    margin: 0;
  }
  ${props =>
    props.simple &&
    css`
      margin: 0 !important;
    `};
`;

const HeaderMainContentMobileMenuButton = styled.div`
  flex: 0 0 25%;
  max-width: 25%;
  padding: 0 20px 0 0;
  @media screen and (min-width: ${breakpoint.large}px) {
    display: none;
  }
`;
const MobileMenuButton = styled.button`
  display: block;
  position: relative;
  height: 17.5px;
  width: 17.5px;
  padding: 0;
  border: none;
  outline: none;
  background-color: transparent;
  color: ${color.white};
  cursor: pointer;
`;
const MobileMenuButtonIcon = styled.span`
  position: absolute;
  top: 50%;
  left: 0;
  height: 1px;
  width: 100%;
  background-color: currentColor;
  transition: background-color 0s linear 0.125s;
  &:before,
  &:after {
    content: '';
    position: absolute;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: currentColor;
    transition: top 0.125s ease 0.125s, transform 0.125s ease;
  }
  &:before {
    top: -6px;
  }
  &:after {
    top: 6px;
  }
  ${props =>
    props.active &&
    css`
      background-color: transparent;
      &:before,
      &:after {
        top: 0;
        transition: top 0.125s ease, transform 0.125s ease 0.125s;
      }
      &:before {
        transform: rotate(45deg);
      }
      &:after {
        transform: rotate(-45deg);
      }
    `};
`;

const HeaderMainContentLogo = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  @media screen and (min-width: ${breakpoint.large}px) {
    flex: 0 0 25%;
    max-width: 25%;
    padding: 0 10px 0 0;
  }
  @media screen and (min-width: ${breakpoint.extraLarge}px) {
    padding: 0 20px 0 0;
  }
  ${props =>
    props.simple &&
    css`
      flex: 0 0 50% !important;
      max-width: 50% !important;
      padding: 0 !important;
    `};
`;
const HeaderLogo = styled(Link)`
  display: block;
  max-width: 125px;
  margin: 0 auto;
  ${props =>
    props.simple &&
    css`
      margin: 0 0 0 auto;
    `};
  @media screen and (min-width: ${breakpoint.medium}px) {
    max-width: 162.5px;
  }
  @media screen and (min-width: ${breakpoint.large}px) {
    max-width: 200px;
    margin: 0;
    ${props =>
      props.simple &&
      css`
        margin: 0 auto;
      `};
  }
  > img {
    display: block;
    width: 100%;
    transition: opacity 0.25s ease-out;
    &:hover {
      opacity: 0.875;
    }
    &:active {
      opacity: 0.75;
    }
  }
`;
const HeaderMainContentSearch = styled.div`
  flex: 0 0 50%;
  display: none;
  position: relative;
  max-width: 50%;
  padding: 0 20px;
  @media screen and (min-width: ${breakpoint.large}px) {
    display: block;
  }
  @media screen and (min-width: ${breakpoint.extraLarge}px) {
    padding: 0;
  }
`;
const HeaderMainContentCart = styled.div`
  flex: 0 0 25%;
  display: flex;
  justify-content: flex-end;
  position: relative;
  max-width: 25%;
  padding: 0 0 0 20px;
`;

const HeaderLowerContent = styled.div`
  position: relative;
  @media screen and (min-width: ${breakpoint.large}px) {
    display: none;
  }
`;

const HeaderLower = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: ${color.black};
  transform: translateY(-100%);
  transition: transform 0.25s ease-out;
  @media screen and (min-width: ${breakpoint.large}px) {
    display: block;
  }
  ${props =>
    props.active &&
    css`
      transform: translateY(0);
    `};
  > div {
    opacity: 0;
    transition: opacity 0.125s ease-out;
    ${props =>
      props.active &&
      css`
        opacity: 1;
        transition: opacity 0.125s ease-out 0.125s;
      `};
  }
`;

const HeaderMainContentReturnToStoreLink = styled.div`
  flex: 0 0 50%;
  display: flex;
  max-width: 50%;
  padding: 0 20px 0 0;
  @media screen and (min-width: ${breakpoint.large}px) {
    flex: 0 0 25%;
    max-width: 25%;
  }
`;
const ReturnToStoreLink = styled(Link)`
  color: ${color.white};
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  text-decoration: none;
  letter-spacing: 0.125em;
  line-height: 1.25;
  transition: opacity 0.25s ease-out;
  @media screen and (min-width: ${breakpoint.large}px) {
    font-size: 12px;
  }
  &:hover {
    opacity: 0.875;
  }
  &:active {
    opacity: 0.75;
  }
`;

const HeaderUSP = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 25px;
  background-color: #779182;
  z-index: 149;
  ${hideOnPrint};
  @media screen and (min-width: ${breakpoint.large}px) {
    height: 35px;
  }
  ${props =>
    props.variant === 'secondary' &&
    css`
      background-color: #ced5d1;
      > div {
        > ul {
          color: ${color.black};
          > li {
            > svg {
              > path {
                fill: #779182;
              }
            }
          }
        }
      }
    `};
`;
const HeaderUSPList = styled.ul`
  position: relative;
  list-style: none;
  height: ${10 * 1.25}px;
  margin: 0;
  padding: 0;
  color: ${color.white};
  font-size: 10px;
  line-height: 1.25;
  @media screen and (min-width: ${breakpoint.medium}px) {
    display: flex;
    justify-content: center;
    height: auto;
  }
  @media screen and (min-width: ${breakpoint.large}px) {
    font-size: 14px;
  }
`;

const twoUSPListItemsAnimation1 = keyframes`
  0% {
    opacity: 0;
  }
  ${100 / (20 / 0.25)}% {
    opacity: 1;
  }

  ${100 / 2 - 100 / (20 / 0.25)}% {
    opacity: 1;
  }
  ${100 / 2}% {
    opacity: 0;
  }
`;
const twoUSPListItemsAnimation2 = keyframes`
  ${100 / 2}% {
    opacity: 0;
  }
  ${100 / 2 + 100 / (20 / 0.25)}% {
    opacity: 1;
  }

  ${100 - 100 / (20 / 0.25)}% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const threeUSPListItemsAnimation1 = keyframes`
  0% {
    opacity: 0;
  }
  ${100 / (30 / 0.25)}% {
    opacity: 1;
  }

  ${100 / 3 - 100 / (30 / 0.25)}% {
    opacity: 1;
  }
  ${100 / 3}% {
    opacity: 0;
  }
`;
const threeUSPListItemsAnimation2 = keyframes`
  ${100 / 3}% {
    opacity: 0;
  }
  ${100 / 3 + 100 / (30 / 0.25)}% {
    opacity: 1;
  }

  ${(100 / 3) * 2 - 100 / (30 / 0.25)}% {
    opacity: 1;
  }
  ${(100 / 3) * 2}% {
    opacity: 0;
  }
`;
const threeUSPListItemsAnimation3 = keyframes`
  ${(100 / 3) * 2}% {
    opacity: 0;
  }
  ${(100 / 3) * 2 + 100 / (30 / 0.25)}% {
    opacity: 1;
  }

  ${100 - 100 / (30 / 0.25)}% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const HeaderUSPListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  @media screen and (min-width: ${breakpoint.medium}px) {
    position: static;
    justify-content: flex-start;
    top: auto;
    left: auto;
    width: auto;
    max-width: 100%;
    margin: 0 20px 0 0;
  }
  @media screen and (min-width: ${breakpoint.extraMedium}px) {
    margin: 0 40px 0 0;
  }
  @media screen and (min-width: ${breakpoint.extraLarge}px) {
    margin: 0 80px 0 0;
  }
  ${props =>
    (props.numberOfUSPListItems === 2 || props.numberOfUSPListItems === 3) &&
    css`
      opacity: 0;
      animation-delay: -0.25s;
      animation-iteration-count: infinite;
      @media screen and (min-width: ${breakpoint.medium}px) {
        opacity: 1;
        animation-name: none !important;
      }
    `};
  ${props =>
    props.numberOfUSPListItems === 2 &&
    css`
      animation-name: ${twoUSPListItemsAnimation1};
      animation-duration: 20s;
      @media screen and (min-width: ${breakpoint.medium}px) {
        max-width: calc((100% / 2) - ((20px * 1) / 2));
      }
      @media screen and (min-width: ${breakpoint.extraMedium}px) {
        max-width: calc((100% / 2) - ((40px * 1) / 2));
      }
      @media screen and (min-width: ${breakpoint.extraLarge}px) {
        max-width: calc((100% / 2) - ((80px * 1) / 2));
      }
      &:nth-child(2) {
        animation-name: ${twoUSPListItemsAnimation2};
      }
    `};
  ${props =>
    props.numberOfUSPListItems === 3 &&
    css`
      animation-name: ${threeUSPListItemsAnimation1};
      animation-duration: 30s;
      @media screen and (min-width: ${breakpoint.medium}px) {
        max-width: calc((100% / 3) - ((20px * 2) / 3));
      }
      @media screen and (min-width: ${breakpoint.extraMedium}px) {
        max-width: calc((100% / 3) - ((40px * 2) / 3));
      }
      @media screen and (min-width: ${breakpoint.extraLarge}px) {
        max-width: calc((100% / 3) - ((80px * 2) / 3));
      }
      &:nth-child(2) {
        animation-name: ${threeUSPListItemsAnimation2};
      }
      &:nth-child(3) {
        animation-name: ${threeUSPListItemsAnimation3};
      }
    `};
  &:last-child {
    @media screen and (min-width: ${breakpoint.medium}px) {
      margin: 0;
    }
  }
  > svg {
    flex: 0 0 auto;
    width: 10px;
    margin: 0 5px 0 0;
    @media screen and (min-width: ${breakpoint.large}px) {
      margin: 1px 5px 0 0;
    }
  }
  > span {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

Header.defaultProps = {
  viewstate: Map(),
  headerUspList: [],
  headerUSPVariantSecondary: false,
  headerUSPShowIcons: true
};

Header.propTypes = {
  viewstate: PropTypes.instanceOf(Map),
  location: PropTypes.object.isRequired,
  removeQuickSearch: PropTypes.func.isRequired,
  setViewstate: PropTypes.func.isRequired,
  removeViewstate: PropTypes.func.isRequired,
  headerUspList: PropTypes.array,
  headerUSPVariantSecondary: PropTypes.bool,
  headerUSPShowIcons: PropTypes.bool
};

export default connect(Header, { setViewstate, removeViewstate, removeQuickSearch }, store => ({
  viewstate: store.viewstate,
  headerUspList: (window.startup || {}).uspTexts,
  headerUSPVariantSecondary: (window.startup || {}).uspBarUseSecondaryColors,
  headerUSPShowIcons: !(window.startup || {}).uspBarHideIcons
}));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js